import { useState } from "react";
import ServiceCard from "../../../components/feature/ServiceCard";
import { draftingServices } from "../../../mocks/draftingServices";
import { takeoffServices } from "../../../mocks/takeoffServices";

export default function ServicesSection() {
  const [activeTab, setActiveTab] = useState("drafting");


  // Determine which list to show
  const currentServices = activeTab === "drafting" ? draftingServices : takeoffServices;

  return (
    <section id="services" className="py-20 bg-[#dbcfbf]/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold text-[#212026] mb-4">
            Our Services
          </h2>
          <p className="text-xl text-[#889d8f] max-w-3xl mx-auto mb-8">
            Comprehensive engineering, drafting, and estimation solutions using
            industry-leading methodologies.
          </p>

          {/* --- Toggle Switch --- */}
          <div className="flex justify-center">
            <div className="bg-white dark:bg-slate-800 p-1.5 rounded-full shadow-lg inline-flex relative z-10">
              <button
                onClick={() => setActiveTab("drafting")}
                className={`px-6 md:px-8 py-3 rounded-full text-sm md:text-base font-bold transition-all duration-300 ${activeTab === "drafting"
                  ? "bg-[#F5A623] text-white shadow-md"
                  : "text-gray-500 hover:text-[#F5A623] dark:text-gray-400"
                  }`}
              >
                Drafting Services
              </button>
              <button
                onClick={() => setActiveTab("takeoff")}
                className={`px-6 md:px-8 py-3 rounded-full text-sm md:text-base font-bold transition-all duration-300 ${activeTab === "takeoff"
                  ? "bg-[#F5A623] text-white shadow-md"
                  : "text-gray-500 hover:text-[#F5A623] dark:text-gray-400"
                  }`}
              >
                Takeoff Services
              </button>
            </div>
          </div>
        </div>

        <section className="py-10 dark:bg-slate-900 transition-colors duration-300 min-h-[600px]">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {currentServices.map((service: any, index: number) => (
              <ServiceCard
                key={`${activeTab}-${index}`}
                title={service.title}
                description={service.description}
                image={service.image}
                tags={service.tags}
                icon={service.icon || (
                  service.title.includes("WiFi") ? "ri-wifi-line" :
                    service.title.includes("Lighting") ? "ri-lightbulb-line" :
                      service.title.includes("3D") ? "ri-image-2-line" :
                        service.title.includes("Plan") ? "ri-layout-2-line" :
                          "ri-service-line"
                )}
              />
            ))}


          </div>
        </section>
      </div>
    </section>
  );
}